import React, {useEffect, useMemo, useState} from 'react';
import CustomSelect from "../form/CustomSelect";
import {useTranslation} from "react-i18next";

const FetchOptionsSelect = ({ onChange,defaultFetchOptionIds = [], fetchOptionsFunction, fetchOptionsFilterParams, formatFetchOptionsFunction, loadingPlaceholder, placeholderText, ...props }) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [availableFetchOptions, setAvailableFetchOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const memoizedFetchOptionsFilterParams = useMemo(() => fetchOptionsFilterParams, [JSON.stringify(fetchOptionsFilterParams)]);

    const handleChange = (options) => {
        setSelectedOptions(options);
        let selectedIds;
        let selectedStates = [];
        if(props.isMulti){
            selectedIds = options ? options.map(option => option.value) : [];
            selectedStates = options ? options.map(option => option.state) : [];
        } else {
            selectedIds = options ? options.value : '';
            selectedStates = options ? options.state : '';
        }
        onChange(selectedIds);
        props?.setProvinceCode && props?.setProvinceCode(selectedStates);
    };

    const setFetchOptions = async function (){
        try {
            setLoading(true);
            const response = await fetchOptionsFunction(fetchOptionsFilterParams);
            const formattedFetchOptions = formatFetchOptionsFunction(response);
            setAvailableFetchOptions(formattedFetchOptions);
            setLoading(false);

        } catch (err){
            setLoading(false);
            console.log("Error fetching data: " + err);
        }
    }

    useEffect(() => {
        if(!props.isDisabled){
            setFetchOptions();
        }
    }, [memoizedFetchOptionsFilterParams]);

    useEffect(() => {
        if(!loading && defaultFetchOptionIds){
            const initialSelectedOptions = availableFetchOptions.filter(fetchOption =>
                defaultFetchOptionIds.includes(fetchOption.value)
            );
            setSelectedOptions(initialSelectedOptions);
        }
    }, [availableFetchOptions]);



    return (
        <CustomSelect
            placeholder={loading ? (loadingPlaceholder ? <div>{loadingPlaceholder}</div> :
                    <div>{t("Loading available options...")}</div>) :
                (placeholderText ? <div>{placeholderText}</div> : <div>{t("Search and select options")}</div>)}
            options={availableFetchOptions}
            value={selectedOptions}
            onChange={handleChange}
            {...props}
        />
    );
};

export default FetchOptionsSelect;
